
import { put, select } from 'redux-saga/effects'
import { routes } from '../../app/constants'
import {
  LOGIN,
  LOGIN_ERROR,
  LOGOUT,
  // SHOW_ACCOUNT_NAME_ERROR,
  // SHOW_PASSWORD_ERROR,
  showAccountNameError,
  showPasswordError,
} from './loginActions'
import { showError } from '../../store/actions/appActions'
import { clearDataGridState } from './utils'

export default [
  [LOGIN, ({ payload: { history } }) => {
    history.push(routes.TRANSCRIPT_VIEWER);
  }],

  [LOGIN_ERROR, function* ({ payload: { history, response } }) {
    const { texts } = yield select(state => state.app);
    const NO_SUCH_ACCOUNT = 'No such account';
    const INCORRECT_PASSWORD = 'Incorrect password';
    history.push(routes.LOGIN);
    if (~response.errorDescription.indexOf(NO_SUCH_ACCOUNT)) {
      yield put(showAccountNameError(texts['account-name-error']));
    } else if (~response.errorDescription.indexOf(INCORRECT_PASSWORD)) {
      yield put(showPasswordError(texts['password-error']));
    } else {
      yield put(showError(response.errorDescription));
    }
  }],

  [LOGOUT, ({ payload: { history } }) => {
    clearDataGridState()
    history.push(routes.LOGIN);
  }],

  // [SHOW_ACCOUNT_NAME_ERROR, function* ({ payload: errorStr }) {
  //   yield put(showError(errorStr));
  // }],

  // [SHOW_PASSWORD_ERROR, function* ({ payload: errorStr }) {
  //   yield put(showError(errorStr));
  // }],
]
